// extracted by css-extract-rspack-plugin
export default {"content":"content-VIL31D"};